import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Observable } from 'rxjs';
import { Cataloghi } from 'my-lib-sanfelici';
import { CataloghiService } from 'my-lib-sanfelici';

@Component({
  selector: 'app-cataloghi-list',
  templateUrl: './cataloghi-list.component.html',
  styleUrls: ['./cataloghi-list.component.css']
})
export class CataloghiListComponent implements OnInit {

cataloghi: Observable<Cataloghi[]>;
  constructor(
    private cataloghiservice: CataloghiService) {
  }
  cancel(key: string) {
      this.cataloghiservice.delete(key);
      }

  ngOnInit() {
    this.cataloghi = this.cataloghiservice.list();

  }
}
